import { render, staticRenderFns } from "./ChangeIdentifyModal.vue?vue&type=template&id=ec83a9ca&scoped=true&"
import script from "./ChangeIdentifyModal.vue?vue&type=script&lang=js&"
export * from "./ChangeIdentifyModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeIdentifyModal.vue?vue&type=style&index=0&id=ec83a9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec83a9ca",
  null
  
)

export default component.exports